/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-this-in-sfc */
import React from "react";
import ColorPicker from "./ColorPicker";

export default function Background({
  currentConfig = "",
  changeBackgroundColor,
  updateConfig,
}) {
  const convertColorValue = (value) => {
    let color = value;
    if (typeof currentConfig === "number") {
      color = `#${Number(currentConfig).toString(16).toUpperCase()}`;
    }

    return color;
  };

  return (
    <div className="ambientContainer">
      <div className="ambientHeader">
        <div className="ambientHeaderInfo">
          <div className="ambientTitle">Background Color</div>
        </div>
      </div>
      <div className="formWrapper">
        <div className="colorPickerContainer">
          <ColorPicker
            title="Color Picker"
            color={convertColorValue(currentConfig)}
            onColorChange={(value) => {
              console.log("on ambient light color picker", value);
              currentConfig = parseInt(value.slice(1), 16);
              changeBackgroundColor(currentConfig);
              updateConfig(currentConfig);
            }}
          />
        </div>
      </div>
    </div>
  );
}
